export const CLEAR_CARDS_SERCH = "CLEAR_CARDS_SERCH";
export const UPDATE_CARDS_SELECTS = "UPDATE_CARDS_SELECTS";
export const UPDATE_CARDS_TEXT = "UPDATE_CARDS_TEXT";
export const CLEAR_CARDS_SEARCH_SUCCESS = "CLEAR_CARDS_SEARCH_SUCCESS";
export const UPDATE_CARDS_SELECTS_SUCCESS = "UPDATE_CARDS_SELECTS_SUCCESS";
export const UPDATE_CARDS_SELECTS_FAIL = "UPDATE_CARDS_SELECTS_FAIL";
export const UPDATE_CARDS_TEXT_SUCCESS = "UPDATE_CARDS_TEXT_SUCCESS";
export const UPDATE_CARDS_TEXT_FAIL = "UPDATE_CARDS_TEXT_FAIL";
export const CLEAR_PRODUCTS_SERCH = "CLEAR_PRODUCTS_SERCH";
export const CLEAR_PRODUCTS_SEARCH_SUCCESS = "CLEAR_PRODUCTS_SEARCH_SUCCESS";
export const UPDATE_PRODUCTS_SELECTS = "UPDATE_PRODUCTS_SELECTS";
export const UPDATE_PRODUCTS_TEXT = "UPDATE_PRODUCTS_TEXT";
export const UPDATE_PRODUCTS_SELECTS_SUCCESS = "UPDATE_PRODUCTS_SELECTS_SUCCESS";
export const UPDATE_PRODUCTS_SELECTS_FAIL = "UPDATE_PRODUCTS_SELECTS_FAIL";
export const UPDATE_PRODUCTS_TEXT_SUCCESS = "UPDATE_PRODUCTS_TEXT_SUCCESS";
export const UPDATE_PRODUCTS_TEXT_FAIL = "UPDATE_PRODUCTS_TEXT_FAIL";